<template>
  <div class="modal order-modal" @click="$parent.closeOrderModal">
    <div class="overlay" @click="$parent.closeOrderModal"></div>
    <div class="wrapper" @click.stop>
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img class="close" @click="$parent.closeOrderModal" src="./../images/close.svg" />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="modal-top">
                  <button class="button black">
                    <img class="back" @click="$parent.openTopUpModal" src="./../images/back.svg" />
                  </button>
                  <div class="title medium payment-title">{{ $t('PAYMENT DETAILS') }}</div>
                </div>
                <div class="fields">
                  <label>
                    <span class="desc">{{ $t('FIRST NAME') }}</span>
                    <input type="text" v-model="name" :placeholder="$t('First Name')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t('LAST NAME') }}</span>
                    <input type="text" v-model="surname" :placeholder="$t('Last Name')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t('EMAIL') }}</span>
                    <input type="email" v-model="email" :placeholder="$t('user123@gmail.com')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t('PHONE') }}</span>
                    <input type="text" v-model="phone" @input="allowOnlyNumbers" :placeholder="$t('+1 234 5678 9012')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t('ADDRESS') }}</span>
                    <input type="text" v-model="address" :placeholder="$t('Address')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t('CITY') }}</span>
                    <input type="text" v-model="city" :placeholder="$t('City')"/>
                  </label>
                  <label>
                    <span class="desc">{{ $t('COUNTRY') }}</span>
                    <select v-model="country">
                      <option value="" disabled selected>{{ $t('Country') }}</option>
                      <option v-for="item in countryOptions" :value="item.id" :key="item.title">{{item.title}}</option>
                    </select>
                  </label>
                  <label>
                    <span class="desc">{{ $t('ZIP-CODE') }}</span>
                    <input type="text" v-model="postCode" :placeholder="$t('1234')"/>
                  </label>
                </div>
                <div class="chekbox-container">
                  <label class="chekbox-label">
                    <div class="chekbox-label-wrapper">
                      <input 
                        v-model="terms"
                        type="checkbox" 
                        name="terms" 
                      >
                      <div class="checkbox" />
                      <span class="desc">{{ $t('I agree with') }} </span>
                      <a 
                        class="desc orange"
                        @click="$parent.goToPage('privacy')"
                      > 
                        {{ $t('privacy policy') }}
                      </a>
                      <span class="desc"> {{ $t('and') }} </span>
                      <a 
                        class="desc orange"
                        @click="$parent.goToPage('terms')"
                      > 
                        {{ $t('terms and conditions') }}
                      </a>
                    </div>
                  </label>
                </div>
                <div class="modal-bottom">
                  <div class="text">
                    <span class="title medium">{{ $t('You get:') }}</span>
                    <span class="title medium">
                      {{ $parent.topUpAmount }}
                      {{ currency }}
                    </span>
                  </div>
                  <div :class="['button next-button', {'disabled': !requiredFieldsAreFilled}]" @click="submit('card')">{{ $t('NEXT') }}</div>
                </div>
                <transition name="fade">
                  <div class="desc error" v-if="$parent.error">{{$parent.error}}</div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderModal",
  props: ['currency'],
  components: {},
  data: function () {
    return {
      amount: 5,
      countryOptions: [],
      name: '',
      surname: '',
      phone: '',
      email: '',
      address: '',
      city: '',
      country: '',
      postCode: '',
      terms: ''
    };
  },
  computed: {
    requiredFieldsAreFilled() {
      let fieldsAreFilled;
      if(
        this.name && this.surname  && this.phone && 
        this.email && this.country && 
        this.city && this.address  && this.terms
        && this.postCode 
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    }
  },
  mounted() {
    this.getProfile();
    this.getCounties();
  },
  methods: {
    allowOnlyNumbers(){
      this.phone = this.phone.replace(/[^0-9.,]/g, '');
      const parts = this.phone.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }
      this.phone = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
    },
    submit(payType) {
      let amount = this.$parent.topUpAmount;
      let data = {
        "first_name": this.name,
        "last_name": this.surname,
        "phone": this.phone,
        "email": this.email,
        "country_id": this.country,
        "city": this.city,
        "address": this.address,
        "zip": this.postCode,
        "amount": amount,
        "paymentType": payType,
      }
      console.log('OrderModal submit called with data:', data);
      this.$emit('topUp', data)
    },
    getProfile() {
      this.$http.get(process.env.VUE_APP_API + 'user/profile')
      .then((res) => {
          this.name = res.data.name;
          this.surname = res.data.surname;
          this.phone = res.data.phone;
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    },
    getCounties() {
      this.$http.get(process.env.VUE_APP_API + 'countries')
      .then((res) => {
          this.countryOptions = res.data.payload;
         
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    },
    toCheckout() {
      this.$parent.closeTopUpModal();
    },
  },
};
</script>
